export const LOCATION_CLONE_STATUS = 'LOCATION_CLONE_STATUS'
export const SET_CLONE_ID = 'SET_CLONE_ID'
export const LOCATION_CLONED = 'LOCATION_CLONED'
export const SET_SHOW_SELECTED_LOCATION = 'SET_SHOW_SELECTED_LOCATION'
export const SET_LOCATION_SEARCH_VALUE = 'SET_LOCATION_SEARCH_VALUE'
export const SET_ASSOCIATED_GROUP_SEARCH = 'SET_ASSOCIATED_GROUP_SEARCH'
export const RESET_LOCATIONS = 'RESET_LOCATIONS'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'